import React from 'react';
import '../less/personalInsurance.less';
import advantages_img_1 from '../img/advantages_img_1.png';
import advantages_img_2 from '../img/advantages_img_2.png';
import advantages_img_3 from '../img/advantages_img_3.png';
import advantages_img_4 from '../img/advantages_img_4.png';
import advantages_img_5 from '../img/advantages_img_5.png';
import advantages_img_6 from '../img/advantages_img_6.png';
import advantages_img_7 from '../img/advantages_img_7.png';
import hero_img from '../img/hero_img.png';
import Hero from '../../../../../auxiliary-components/shared/HeroBlock';
import Tariffs from '../../../../../auxiliary-components/shared/TariffsBlock';
import advantagesItemsData from '../enums/advantages_items.json';
import QuestionsFullAdmin from '../../../../../auxiliary-components/shared/QuestionsFullAdmin';
import insurerInfoDataConfig from '../enums/insurer_info_data.json';
import Tabs from '../../../../../auxiliary-components/shared/Tabs';
import { insuranceDocumentsKrainaCompanyLink, insuranceKrainaDocumentsProductLink } from '../../../../../services/urls/urls';
import { Preloader } from 'MWComponents';
import InsuranceIntermediaryInfo from '../../../../../auxiliary-components/shared/InsuranceIntermediaryInfo';
import Advantages from '../../../../../auxiliary-components/shared/AdvantagesBlock';
import { mapInsuranceDetailedInfoToTariffs } from '../../../../../helpers/utils/mapInsuranceDetailedInfoToTariffs';
import { canUseDOM } from '../../../../../helpers/canUseDOM';

export default function template() {
  const page = "personal-insurance";

  const tabs = [{tab: 'insurer-info', title: 'PERSONAL_INSURANCE_TABS_TITLE_01'},
        {tab: 'insurance-info', title: 'PERSONAL_INSURANCE_TABS_TITLE_02'},
        {tab: 'intermediary-info', title: 'PERSONAL_INSURANCE_TABS_TITLE_03'}];

  const imagesMap = {
    advantages_img_1,
    advantages_img_2,
    advantages_img_3,
    advantages_img_4,
    advantages_img_5,
    advantages_img_6,
    advantages_img_7
  };

  const linksMap = { insuranceDocumentsKrainaCompanyLink, insuranceKrainaDocumentsProductLink };

  const insurerInfoData = insurerInfoDataConfig.map(item => ({
    ...item,
    values: item.values.map(val => {
      if (val.type === 'button') {
        return {
          ...val,
          btnLink: linksMap[val.btnLink],
        };
      }

      return val;
    })
  }));

  const hero_data = {
    title: "PERSONAL_INSURANCE_HERO_TITLE",
    text: "PERSONAL_INSURANCE_HERO_TEXT"
  }
  
  const advantagesItems = advantagesItemsData.map(item => ({
    ...item,
    img: imagesMap[item.img]
  }));

  const detailedInsuranceInfoItems = this.widgetsHelper.getWidgetFrom.call(this, 'detailedInsuranceInfoWidget', 'questions');
  const detailedInsuranceInfoTariffsItems = mapInsuranceDetailedInfoToTariffs(detailedInsuranceInfoItems);

  const detailedIntermediaryInfoItems = this.widgetsHelper.getWidgetFrom.call(this, 'detailedIntermediaryInfoWidget', 'questions');
  const detailedIntermediaryInfoTariffsItems = mapInsuranceDetailedInfoToTariffs(detailedIntermediaryInfoItems);

  return (
    <div className="personal-insurance">
      <Hero
        data={hero_data}
        img={hero_img}
      />
      <div className={`content${(this.state.detailedInsuranceInfoTab || this.state.intermediaryInsuranceInfoTab) ? ' hidden' : ''}`}>
        <div className="general-info">
          <div className="container">
            <div className="general-info__body">
              <h2 className="general-info__title">{this.l10n('PERSONAL_INSURANCE_GENERAL_INFO_TITLE')}</h2>
              <div className="general-info__text">{this.l10n('PERSONAL_INSURANCE_GENERAL_INFO_TEXT')}</div>
              <div className="general-info__contract-drawing contract-drawing">
                <div className="contract-drawing__title">{this.l10n('PERSONAL_INSURANCE_CONTRACT_DRAWING_TITLE')}</div>
                <ul className="contract-drawing__items">
                  <li>{this.l10n('PERSONAL_INSURANCE_CONTRACT_DRAWING_LIST_01')}</li>
                  <li>{this.l10n('PERSONAL_INSURANCE_CONTRACT_DRAWING_LIST_02')}</li>
                  <li>{this.l10n('PERSONAL_INSURANCE_CONTRACT_DRAWING_LIST_03')}</li>
                </ul>
              </div>
              <div className="general-info__purpose purpose">
                <h3 className="purpose__title">{this.l10n('PERSONAL_INSURANCE_PURPOSE_TITLE')}</h3>
                <div className="purpose__text">
                  <p>{this.l10n('PERSONAL_INSURANCE_PURPOSE_TOP_TEXT_01')}</p>
                  <p>{this.l10n('PERSONAL_INSURANCE_PURPOSE_TOP_TEXT_02')}</p>
                </div>
                <ul className="purpose__items">
                  <li>{this.l10n('PERSONAL_INSURANCE_PURPOSE_LIST_01')}</li>
                  <li>{this.l10n('PERSONAL_INSURANCE_PURPOSE_LIST_02')}</li>
                  <li>{this.l10n('PERSONAL_INSURANCE_PURPOSE_LIST_03')}</li>
                  <li>{this.l10n('PERSONAL_INSURANCE_PURPOSE_LIST_04')}</li>
                </ul>
                <div className="purpose__text">{this.l10n('PERSONAL_INSURANCE_PURPOSE_BOTTOM_TEXT')}</div>
              </div>
            </div>
          </div>
        </div>
        <Advantages
          items={advantagesItems}
          title={'PERSONAL_INSURANCE_ADVANTAGES_TITLE'}
        />
        <Tabs tabs={tabs} toggle={this.toggleTab} tab={this.state.tab} page={page}>
          <Tariffs
            items={insurerInfoData}
            title={'PERSONAL_INSURANCE_TARIFFS_INSURER_INFO_TITLE'}
            page={page}
            titleTag={"div"}
          />
          {this.state.detailedInsuranceInfoWidget_loading ? (canUseDOM ? <Preloader /> : null) : (
            (detailedInsuranceInfoTariffsItems && detailedInsuranceInfoTariffsItems.length > 0) ? (
              <Tariffs
                title={'PERSONAL_INSURANCE_TARIFFS_INSURANCE_INFO_TITLE'}
                items={detailedInsuranceInfoTariffsItems}
                alignItems="start"
                onBtnClick={this.toggleDetailedInsuranceInfoTab}
                btnText={'PERSONAL_INSURANCE_TARIFFS_INSURANCE_INFO_BTN'}
                insuranceInfo
                page={page}
              />
            ) : null
          )}
          {this.state.detailedIntermediaryInfoWidget_loading ? (canUseDOM ? <Preloader /> : null) : (
            (detailedIntermediaryInfoTariffsItems && detailedIntermediaryInfoTariffsItems.length > 0) ? (
              <Tariffs
                title={'PERSONAL_INSURANCE_TARIFFS_INTERMEDIARY_INFO_TITLE'}
                items={detailedIntermediaryInfoTariffsItems}
                alignItems="start"
                onBtnClick={this.toggleIntermediaryInsuranceInfoTab}
                btnText={'PERSONAL_INSURANCE_TARIFFS_INTERMEDIARY_INFO_BTN'}
                insuranceInfo
                page={page}
              />
            ) : null
          )}
        </Tabs>
      </div>
      <div className={`content${!this.state.detailedInsuranceInfoTab ? ' hidden' : ''}`}>
        <QuestionsFullAdmin
          title={'PERSONAL_INSURANCE_DETAILED_INFO_TITLE'}
          toggleFaqTab={this.toggleDetailedInsuranceInfoTab}
          widget={detailedInsuranceInfoItems}
        />
      </div>
      <div className={`content${!this.state.intermediaryInsuranceInfoTab ? ' hidden' : ''}`}>
        <QuestionsFullAdmin
          title={'PERSONAL_INSURANCE_INTERMEDIARY_INFO_TITLE'}
          toggleFaqTab={this.toggleIntermediaryInsuranceInfoTab}
          widget={detailedIntermediaryInfoItems}
          display={"block"}
        />
      </div>
    </div>
  )
}
